// extracted by mini-css-extract-plugin
module.exports = {"actionWrapper":"action-required-banner_actionWrapper__ugm4f","daysLeftMessage":"action-required-banner_daysLeftMessage__3B2jI","action":"action-required-banner_action__ukrXO"};